import React from 'react';
import * as C from "./styles";
const Header = () => {
  return (
    <C.Container>
        <C.Header>
            <C.Title>Meu controle Financeiro</C.Title>
        </C.Header>
    </C.Container>
  )
}

export default Header;